

import {PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {sendSlackMessageTracked} from "../../models/notifications";

const CheckoutForm = () => {


    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        sendSlackMessageTracked(`Client has reached default new. 🇮🇶`)
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const baseURL = window.location.origin;
        const returnURL = `${baseURL}/thank-you`;
        const response = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: returnURL,
            },
        });

        if (response.error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            // setErrorMessage(response.error.message);
            console.log("This is your error", response.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            console.log("Converting the cart data")
            // convertCartToPurchaseData()
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement options={{
                layout: 'accordion',
            }} />
            <button className="bg-green-600 hover:bg-green-700 text-white w-full rounded my-4 custom-font">Submit</button>
            <div className="mb-4 border-t border-gray-300" />
        </form>
    );
};

export default CheckoutForm;